import { render, staticRenderFns } from "./accounts_registration_dialog.vue?vue&type=template&id=4f5edb3c"
import script from "./accounts_registration_dialog.vue?vue&type=script&lang=js"
export * from "./accounts_registration_dialog.vue?vue&type=script&lang=js"
import style0 from "./accounts_registration_dialog.vue?vue&type=style&index=0&id=4f5edb3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports